import $ from 'jquery';
import intersection from 'lodash/intersection';
import cloneDeep from 'lodash/cloneDeep';
import '../vendor/slick-carousel';

let mapping = {};

/**
 * Add product list items campaign classes.
 * Uses global campaignClassMapping and item data-campaigns attribute
 *
 * @param  {jQuery} $container
 */
export function addCampaignClasses ($container) {

	mapping = window.mapping || {};

	if (!('campaignClass' in mapping)) {
		return;
	}
	$container.find('[data-campaigns]:not(.cclass-added)').each(function () {
		const $item = $(this);
		const ids = String($item.data('campaigns')).split(',');
		let campaignClassAdded = false;
		for (let n = 0; n < ids.length; n++) {
			if (mapping.campaignClass[ids[n]]) {
				$item.addClass('cclass-added ' + mapping.campaignClass[ids[n]]);
				campaignClassAdded = true;
			}
		}
		if (campaignClassAdded) {
			//$item.find('.list-badges').append('<div class="list-badge day-badge">');
		}
	});
}

export function customPagination(event, slick, currentSlide, nextSlide, $carousel) {
	const $customPagination = $carousel.siblings('.custom-pagination').find('.status');
	const i = (currentSlide ? currentSlide : 0) + 1;
	// show pagination based on carousel's scroll position.
	let slidesToScroll = 1;
	if (slick.activeBreakpoint && slick.breakpointSettings && slick.breakpointSettings[slick.activeBreakpoint].slidesToScroll) {
		slidesToScroll = slick.breakpointSettings[slick.activeBreakpoint].slidesToScroll
	}
	const carouselScrollPosition = Math.ceil(i / slidesToScroll);
	const carouselScrollMax = Math.ceil(slick.slideCount / slidesToScroll)
	$customPagination.text(carouselScrollPosition + ' / ' + carouselScrollMax);
}


export function productCarousel(cssClass) {
	$(cssClass).each(function() {
		const $carousel = $(this);

		const conf = {
			infinite: false,
			speed: 300,
			centerMode: false,
			variableWidth: false,
			mobileFirst: true,
			slidesToShow: 2,
			slidesToScroll: 2,
			draggable: true,
			dots: false,
			arrows: true,
			lazyLoad: 'ondemand',
			prevArrow: $carousel.next().find('.prev'),
			nextArrow: $carousel.next().find('.next'),
			responsive: [
				{
					breakpoint: 480-1,
					settings: {
						asNavFor: false,
					}
				},
				{
					breakpoint: 768-1,
					settings: {
						slidesToShow: 2.5,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: 990-1,
					settings: {
						prevArrow: '<div class="slick-next-arrow"></div>',
						nextArrow: '<div class="slick-prev-arrow"></div>',
						slidesToShow: 2.5,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: 1024-1,
					settings: {
						slidesToShow: 3.5,
						slidesToScroll: 3,
						prevArrow: '<div class="slick-next-arrow"></div>',
						nextArrow: '<div class="slick-prev-arrow"></div>',
					}
				},
				{
					breakpoint: 1400-1,
					settings: {
						slidesToShow: 4.5,
						slidesToScroll: 4,
						prevArrow: '<div class="slick-next-arrow"></div>',
						nextArrow: '<div class="slick-prev-arrow"></div>',

					}
				},
			]
		};

		const carouselConf = cloneDeep(conf);

		if($carousel.closest('.static-category-lander.new-category-landing').length){
			// In on the new category landing page we want to show a peek of the next
			// carousel item, so increasing the slidesToShow by half increments here.
			carouselConf.responsive.forEach(function(element, index) {
				if(element.settings.slidesToShow>2) {
					// Also display the arrows for a few smaller
					carouselConf.responsive[index].settings.arrows = true;
				}
				//carouselConf.responsive[index].settings.slidesToShow += 0.5;
			});
			//carouselConf.responsive[0].settings.slidesToShow = 2.5;
			//carouselConf.responsive[3].settings.slidesToShow = 3.5;
			// carouselConf.responsive[0].settings.slidesToShow = 1.5;

			carouselConf.mobileFirst = false; // If this is true, it breaks the mobile view slidesToShow setting.
			carouselConf.slidesToShow = 5.5; // Default layout (bigger than biggest breakpoint) assumes 1 item?
			carouselConf.slidesToScroll = 5;
			carouselConf.arrows = true;
		}

		$carousel.on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
			customPagination(event, slick, currentSlide, nextSlide, $carousel);
		}).slick(carouselConf);

		let scrolling = false;
		const swipeSensitivity = 15; //bigger value demands bigger swipe
		$carousel.on('mousewheel', (e) => {
			if (e.originalEvent.deltaX !== 0) {
				// e.preventDefault();
				e.stopPropagation();

				if (!scrolling && Math.abs(e.originalEvent.deltaX) > swipeSensitivity) {
					scrolling = true;
					setTimeout(() => {
						scrolling = false;
					}, 500);

					if (e.originalEvent.deltaX > 0) {
						$(this).slick('slickNext');
					} else {
						$(this).slick('slickPrev');
					}
				}
			}
		});

	});

	$(document).on('click', '.product-carousel-wrapper .carousel-filter', function(e){
		e.preventDefault();

		var targetgroups = $(this).data('targetgroup').split(',');
		var $carouselWrapper = $(this).closest('.product-carousel-wrapper');
		$carouselWrapper.find('.carousel-filter').removeClass('active');
		$(this).addClass('active');

		$carouselWrapper.find('.product-carousel').slick('slickUnfilter').slick('slickFilter', function(index){
			var itemTargetgroups = [];
			try{
				itemTargetgroups = $(this).data('targetgroup').split(',');
			}catch(e){
				console.log(e);
			}
			if( intersection(targetgroups, itemTargetgroups).length > 0 ){
				return true;
			}
		});
	});

	addCampaignClasses($('.product-carousel'));
}
